<div [class]="containerClass" class="w-full">
  @if (label) {
    <label [for]="id" [class]="getLabelClasses()">{{ label }}</label>
  }

  <div class="w-full relative">
    @if (formControl) {
      <input
        pInputText
        [id]="id"
        [type]="type"
        [placeholder]="placeholder"
        [required]="required"
        [disabled]="disabled"
        [value]="formControl.value"
        (input)="onFormControlInput($event)"
        [ngClass]="getInputClasses()"
        (blur)="onTouched()"
        class="w-full"
      />
    } @else {
      <input
        pInputText
        [id]="id"
        [type]="type"
        [placeholder]="placeholder"
        [required]="required"
        [disabled]="disabled"
        [value]="value"
        [ngClass]="getInputClasses()"
        (input)="onInput($event)"
        (blur)="onTouched()"
        class="w-full"
      />
    }
  </div>

  <span
    [class]="errorClass"
    role="alert"
    [style.display]="showError && errorMessage ? 'block' : 'none'"
    [style.min-height]="'1.25rem'"
    >{{ errorMessage || '&nbsp;' }}</span
  >
</div>
